---
title: Get Started
---

import PublicOverview from './_install_public.mdx'
import OverviewInstallChoice from './_install_choice.mdx'

<PublicOnly>
  <PublicOverview />
</PublicOnly>

To continue please select in which environment you are running your Postgres database:

<OverviewInstallChoice />

<PublicOnly>
  <div>
    <p>If you're interested in integrating pganalyze with your database hosting provider but don't see it listed as officially supported, you can follow the <a href="/docs/install/self_managed/01_create_monitoring_user">manual installation guide for self-managed databases</a>. You will need to run the pganalyze collector on a server with network connectivity to your database in order to monitor your database. Note that system-level statistics (memory usage, I/O, etc.) cannot be collected this way and will not be available in pganalyze. <a href="/docs/log-insights">Log Insights</a> (and the features that depend on it) is only available if your provider exports Postgres logs for your database server <a href="/docs/log-insights/setup/syslog-server">via syslog</a>.</p>
    <br />
    Additional installation notes:
    <ul>
      <li>
        <Link to="install/01_enabling_pg_stat_statements">Enable pg_stat_statements</Link>
      </li>
      <li>
        <Link to="install/amazon_rds/iam_policy">Amazon RDS and Aurora: IAM Policy</Link>
      </li>
    </ul>
  </div>
</PublicOnly>
